import { isNil, map, uniq } from 'lodash'

import { areSameValue } from '../../core/utils'

import { findNodeByFilter } from '../../common/utils'

import { getMenuTitlesWithParents } from '../../menu-title/helpers'

export const transformDishToAiCurationRequest = ({
  dish,
  menuCurationTask,
  locationNames,
  options: {
    shouldSuggestOnlyCourseTypeAndIngredients = false,
    shouldSuggestOnlyLabelsAndIngredients = false,
    shouldSuggestOnlyIngredients = false,
  } = {},
  manualChanges = {},
}) => {
  const selectedMenuTitle = dish.menuTitle
    ? findNodeByFilter(menuCurationTask?.menu?.menuTitles, ({ id }) =>
        areSameValue(id, dish.menuTitle?.id),
      )
    : null

  const menuTitleParents = getMenuTitlesWithParents(
    selectedMenuTitle,
    menuCurationTask?.menu?.menuTitles,
  )

  return {
    payload: {
      id: dish.id,
      name: manualChanges.name || dish.name,
      description: manualChanges.description || dish.description,
      ingredients: manualChanges.ingredients || dish.ingredients,
      styledName: manualChanges.styledName || dish.styledName,
      styledDescription:
        manualChanges.styledDescription || dish.styledDescription,
      styledIngredients:
        manualChanges.styledIngredients || dish.styledIngredients,
      dishTypeId: manualChanges.dishTypeId || dish.dishType?.id,
      dietIds: !isNil(manualChanges.diets)
        ? manualChanges.diets
        : map(dish.diets, 'id'),
      menuTitles: menuTitleParents,
      lowPrice: dish.lowPrice || undefined,
      highPrice: dish.highPrice || undefined,
      addonDescriptors: dish.addonDescriptors,
      dietDescriptors: dish.dietDescriptors,
      miscDescriptors: dish.miscDescriptors,
      allergenDescriptors: dish.allergenDescriptors,
      brandName: menuCurationTask?.menu?.brand?.name,
      brandId: menuCurationTask?.menu?.brand?.id,
      menuId: menuCurationTask?.menu?.id,
      menuCurationTaskId: menuCurationTask?.id,
      locationNames: uniq(map(locationNames, 'name')),
    },
    options: {
      useBrandNameAsLocationName:
        menuCurationTask?.menu?.brand?.useBrandNameAsLocationName,
      shouldSuggestOnlyCourseTypeAndIngredients,
      shouldSuggestOnlyLabelsAndIngredients,
      shouldSuggestOnlyIngredients,
    },
  }
}
